import { activePlanMasters } from "@agentcall/core/master"
import { planMasterType } from "@agentcall/core/type"
import { Label } from "@/components/ui/label"

export type PlanMasterIdOrNull = planMasterType.id | null

interface PlanLabelProps {
  planMasterId: PlanMasterIdOrNull
}

const getPlanVariant = (
  planMasterId: PlanMasterIdOrNull
): "plusPlan" | "standardPlan" | "echoesPlan" | "nonePlan" => {
  switch (planMasterId) {
    case planMasterType.PLAN_MASTER_ID_PLUS:
      return "plusPlan"
    case planMasterType.PLAN_MASTER_ID_ECHOES_FULL:
    case planMasterType.PLAN_MASTER_ID_ECHOES_CALL_CENTER:
      return "echoesPlan"
    case planMasterType.PLAN_MASTER_ID_STANDARD:
      return "standardPlan"
    default:
      return "nonePlan"
  }
}

const getPlanName = (planMasterId: PlanMasterIdOrNull): string => {
  if (!planMasterId) return "未加入"
  const planMaster = activePlanMasters.find((pm) => pm.id === planMasterId)
  return planMaster?.name ?? "未加入"
}

export function PlanLabel({ planMasterId }: PlanLabelProps) {
  return <Label variant={getPlanVariant(planMasterId)}>{getPlanName(planMasterId)}</Label>
}
